import { render, staticRenderFns } from "./ClientHome.vue?vue&type=template&id=d2d0c58e&scoped=true&"
import script from "./ClientHome.vue?vue&type=script&lang=js&"
export * from "./ClientHome.vue?vue&type=script&lang=js&"
import style0 from "./ClientHome.vue?vue&type=style&index=0&id=d2d0c58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d0c58e",
  null
  
)

export default component.exports